var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopWatchGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.1673C11.3137 15.1673 14 12.481 14 9.16732C14 5.85361 11.3137 3.16732 8 3.16732C4.68629 3.16732 2 5.85361 2 9.16732C2 12.481 4.68629 15.1673 8 15.1673ZM8 6.00065C8.27614 6.00065 8.5 6.22451 8.5 6.50065V9.16732C8.5 9.44346 8.27614 9.66732 8 9.66732C7.72386 9.66732 7.5 9.44346 7.5 9.16732V6.50065C7.5 6.22451 7.72386 6.00065 8 6.00065Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16667 1.83398C6.16667 1.55784 6.39052 1.33398 6.66667 1.33398H9.33333C9.60948 1.33398 9.83333 1.55784 9.83333 1.83398C9.83333 2.11013 9.60948 2.33398 9.33333 2.33398H6.66667C6.39052 2.33398 6.16667 2.11013 6.16667 1.83398Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopWatchGray);
export default __webpack_public_path__ + "static/media/stopWatchGray.20695f901d5ceb2d1a8496b5f8120591.svg";
export { ForwardRef as ReactComponent };